










































import Vue from 'vue';

import { ModalOptions } from '@/services/UI';

export default Vue.extend({
    props: {
        id: {
            type: String,
            required: true,
        },
        options: {
            type: Object as () => ModalOptions,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: true,
        },
    },
});
